import OtsRefer from './refer'

OtsRefer.install = Vue => {
  Vue.component(OtsRefer.name,OtsRefer)
}

export default OtsRefer
